import { useState, useRef, useEffect } from "react";
import img from "../../assets/logo_soukhya.png";
import menuIcon from "../../assets/grid.png";

import { MdOutlineSensors } from "react-icons/md";
import { CiSettings } from "react-icons/ci";
import { TbReport } from "react-icons/tb";
import { FaSitemap } from "react-icons/fa";
import { AiOutlineDashboard } from "react-icons/ai";
import { FiLogOut } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu popup when clicking anywhere outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const apps = [
    { name: "Home",      icon: AiOutlineDashboard, navigate: "/" },
    { name: "Site",      icon: FaSitemap,          navigate: "/site-list" },
    { name: "System",    icon: CiSettings,         navigate: "/system-list" },
    { name: "Earth pit", icon: MdOutlineSensors,   navigate: "/sensor" },
    { name: "Reports",   icon: TbReport,           navigate: "/report" },
  ];

  const handleLogout = () => {
    localStorage.clear();
    window.location.replace("/login");
  };

  return (
    <div className="admin-navbar">
      {/* Sleek Glassmorphic Logout Button */}
      <button
        onClick={handleLogout}
        className="flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3.5 py-1.5 rounded-xl bg-rose-500/10 hover:bg-rose-500/20 text-rose-400 hover:text-rose-300 border border-rose-500/20 hover:border-rose-500/40 text-xs font-semibold transition-all duration-200 shadow-sm cursor-pointer group active:scale-95"
        title="Logout"
      >
        <FiLogOut className="w-3.5 h-3.5 transition-transform group-hover:-translate-x-0.5" />
        <span className="hidden sm:inline">Logout</span>
      </button>

      {/* App grid menu */}
      <div className="relative" ref={menuRef}>
        <button
          className="admin-menu-btn"
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          <img src={menuIcon} className="admin-menu-img" alt="menu" />
        </button>

        {isMenuOpen && (
          <div className="admin-menu-dropdown">
            <div className="admin-menu-arrow" />
            <div className="admin-menu-grid">
              {apps.map((app, index) => {
                const isActive = location.pathname === app.navigate || (app.navigate !== "/" && location.pathname.startsWith(app.navigate));
                return (
                  <button
                    key={index}
                    className={`admin-menu-item ${isActive ? "active-menu-item" : ""}`}
                    onClick={() => {
                      setIsMenuOpen(false);
                      navigate(app.navigate);
                    }}
                  >
                    <app.icon className="admin-menu-icon" />
                    <span className="admin-menu-text">{app.name}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Logo */}
      <img 
        src={img} 
        alt="logo" 
        className="admin-logo" 
        onClick={() => navigate("/")} 
        style={{ cursor: "pointer" }} 
      />
    </div>
  );
};

export default NavBar;
